import React, { useEffect, useState } from 'react';

import { TextField, Autocomplete } from '@mui/material';
import { states } from 'src/assets/data/states';

const StateAutocomplete = ({ value: state, onChange }) => {
  const [inputValue, setInputValue] = useState(state?.label || '');

  useEffect(() => {
    if (state) {
      setInputValue(state.label);
    }
  }, [state]);

  const handleInputChange = (event, newInputValue) => {
    setInputValue(newInputValue);
    const selectedState = states.find(({ label, id }) => new Set([label, id]).has(newInputValue));
    if (selectedState) {
      onChange({ target: { name: 'state', value: selectedState } });
    }
  };

  return (
    <>
      <Autocomplete
        fullWidth
        autoHighlight
        options={states}
        value={state || null}
        isOptionEqualToValue={(option, value) => option.id === value?.id}
        getOptionLabel={(option) => option.label}
        onInputChange={handleInputChange}
        onChange={(_, value) => onChange({ target: { name: 'state', value } })}
        inputValue={inputValue}
        renderInput={(params) => (
          <TextField
            label="State"
            {...params}
            sx={{ ...params?.sx, height: '100%' }}
            inputProps={{
              ...params.inputProps,
              // autoComplete: 'new-password', // Avoid browser autofill conflict
            }}
          />
        )}
      />
      <input
        type="text"
        name="state"
        value={inputValue}
        onChange={(e) => handleInputChange(null, e.target.value)}
        style={{ visibility: 'hidden', height: 0, width: 0, margin: 0, padding: 0 }} // Hide the input
      />
    </>
  );
};

export default StateAutocomplete;
